import React, { useState } from 'react';
import telegramIcon from '../assets/telegram.svg';
import xIcon from '../assets/x.svg';
import redditIcon from '../assets/reddit.svg';
import dexscreenerIcon from '../assets/dexscreener.svg';

const Home = () => {
  const [copied, setCopied] = useState(false);
  const contract = '0xD4nKc01n00000000000000000000000000000069';

  const handleCopy = async () => {
    await navigator.clipboard.writeText(contract);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="w-full px-4 sm:px-6 md:px-8 py-8 flex flex-col items-center max-w-7xl mx-auto dark:text-white">
      <h2 className="font-vt323  text-[44px] sm:text-4xl md:text-[44px] text-center mb-4">
        Started by Packs, United by Culture
      </h2>

      {/* Contract Box */}
      <div className="flex items-center justify-between bg-[#3070B7] text-white font-vt323 px-4 py-2 rounded-md shadow-sm w-full max-w-md">
        <span className="truncate text-xl sm:text-[28px]">{contract}</span>
        <button
          onClick={handleCopy}
          className="ml-3 text-xl hover:opacity-80 transition"
          title="Copy to clipboard"
        >
          {copied ? '✔️' : '📋'}
        </button>
      </div>

      {/* Video */}
      <div className="w-full aspect-video mt-11 max-w-4xl rounded-md overflow-hidden">
        <iframe
          src="https://player.vimeo.com/video/1082352061"
          className="w-full h-full"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          loading="lazy"
          title="Dank Coin Video"
        ></iframe>
      </div>

      {/* Social Icons */}
      <div className="flex justify-center items-center gap-4 sm:gap-6 mt-6 flex-wrap">
        <a href="https://t.me/yourchannel" target="_blank" rel="noopener noreferrer" title="Telegram">
          <img src={telegramIcon} alt="Telegram" className="invert w-10 sm:w-[64px]" />
        </a>
        <a href="https://x.com/yourprofile" target="_blank" rel="noopener noreferrer" title="X (Twitter)">
          <img src={xIcon} alt="X" className="invert w-10 sm:w-[64px]" />
        </a>
        <a href="https://reddit.com/r/yourcommunity" target="_blank" rel="noopener noreferrer" title="Reddit">
          <img src={redditIcon} alt="Reddit" className="invert w-10 sm:w-[64px]" />
        </a>
        <a href="https://dexscreener.com/yourtoken" target="_blank" rel="noopener noreferrer" title="Dexscreener">
          <img src={dexscreenerIcon} alt="Dexscreener" className="invert w-10 sm:w-[64px]" />
        </a>
      </div>

      {/* Description */}
      <p className="font-vt323 text-base sm:text-lg md:text-xl text-center text-white px-2 sm:px-4 max-w-2xl mx-auto mt-6">
        Born from the legendary Reddit starter packs — this token is for the culture, the chaos, and the packs. Meme hard, hodl harder.
      </p>
    </div>
  );
};

export default Home;
